import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { SummaryPlainEntityOrSummaryComponent } from '../../../../../common/summary/summary-plain-entity-or-summary/summary-plain-entity-or-summary.component';
import { WorkflowTaskStatus, WorkflowTaskSummaryModel } from '../../model/common/workflowTaskSummary.model';
import { WorkflowTaskModel } from '../../model/common/workflowTask.model';
import { WorkflowTaskTriggerType } from '../../model/trigger/workflowTaskTrigger.model';
import { ErrorMessageResolver } from '../../../../../core/error/errorMessage.resolver';
import {TaskCommandService} from '../../command/taskCommand.service';

@Component({
    selector: 'app-workflow-task-summary',
    templateUrl: './workflow-task-summary.component.html',
    providers: [ErrorMessageResolver]
})
export class WorkflowTaskSummaryComponent extends SummaryPlainEntityOrSummaryComponent<WorkflowTaskSummaryModel, WorkflowTaskModel> {

    WorkflowTaskStatus = WorkflowTaskStatus;
    WorkflowTaskTriggerType = WorkflowTaskTriggerType;
    errorLabel: string;

    constructor(private taskCommandService: TaskCommandService) {
        super();
    }

    view() {
        if (this.clickable) {
            this.redirectToFromCommandAction(this.taskCommandService.viewTask(this.summary));
        }
    }
}
